/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  InputNumber,
  List,
  message,
  Popconfirm,
  Row,
  Select,
  Space,
  Tabs,
  Upload,
} from 'antd';

import { CloseOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';

import CompanyFunctions from '../../../Assets/Scripts/CompanyFunctions';
import Utils from '../../../Assets/Scripts/Utils';
import { api } from '../../../Services/axiosService';

export default function VehicleRegisterDrawerComponent({
  editId,
  isOpen,
  setIsOpen,
  vehicleOptions,
  setVehicleOptions,
  docIds,
}) {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [vehicleTypeOptions, setVehicleTypeOptions] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [requiredDocuments, setRequiredDocuments] = useState([]);

  const clearForm = () => {
    form.resetFields();

    const newValue = form.getFieldsValue();
    newValue.documents = undefined;

    form.setFieldsValue(newValue);
  };

  const submit = async (values) => {
    setLoading(true);
    const data = { ...values, transportCompanyId: editId };

    const vehicleType = vehicleTypeOptions?.find(({ value }) => value === data.type);
    data.type = {
      id: vehicleType.value,
      name: vehicleType.label,
    };

    await CompanyFunctions.saveDocuments(data, 'vehicle');

    await api
      .post(`/Vehicle`, data)
      .then(({ data: resData }) => {
        message.success('Dados salvos!');

        const filteredVehicle = CompanyFunctions.registersWithValidDocs([resData], docIds);

        if (filteredVehicle?.length > 0) {
          vehicleOptions.push({
            ...resData,
            value: resData.id,
            label: `${resData.licensePlate} - ${resData.type.name} (${resData.capacity} pessoas)`,
          });
          setVehicleOptions([...vehicleOptions]);
        }

        clearForm();

        setLoading(false);
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Erro ao enviar os dados do veículo!');
        setLoading(false);
      });
  };

  const getVehicleTypes = async () => {
    const vehicleTypes = await api
      .get(
        '/VehicleType?filters[0].Field=Status&filters[0].Condition=DIFFERENT&filters[0].Value=Inativo'
      )
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os tipos de veículo!');
      });

    const mappedVehicleTypes = vehicleTypes?.map(({ id: value, name: label }) => ({
      label,
      value,
    }));

    setVehicleTypeOptions(mappedVehicleTypes);
  };

  const getDocumentTypes = async () => {
    const documentTypes = await api
      .get(
        '/DocumentType?filters[0].Field=Status&filters[0].Condition=DIFFERENT&filters[0].Value=Inativo'
      )
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os tipos de documento!');
      });

    const mappedDocumentTypes = documentTypes?.map(({ id: value, name: label }) => ({
      label,
      value,
    }));

    setDocumentTypeOptions(mappedDocumentTypes);
    return mappedDocumentTypes;
  };

  const getRequiredDocuments = async () => {
    const docTypes = await getDocumentTypes();

    const reqDocs = docTypes
      ?.filter(({ value }) => docIds.includes(value))
      ?.map(({ label }) => label);

    setRequiredDocuments(reqDocs);
  };

  useEffect(() => {
    getRequiredDocuments();
    getVehicleTypes();
  }, []);

  return (
    <Drawer
      title="Novo Veículo"
      width="30vw"
      onClose={() => setIsOpen(false)}
      open={isOpen}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <Space>
          <Button onClick={() => clearForm()}>Limpar</Button>
          <Button
            onClick={() => form.submit()}
            type="primary"
            style={{ marginRight: '8px', background: '#5cb85c', borderColor: '#5cb85c' }}
          >
            Salvar
          </Button>
        </Space>
      }
    >
      <Form
        form={form}
        disabled={loading}
        name="vehicleForm"
        layout="vertical"
        onFinish={submit}
        autoComplete="off"
      >
        <Tabs>
          <Tabs.TabPane tab="Veículo" key="vehicle">
            <Row gutter={[24]}>
              <Col span={24}>
                <Form.Item
                  label="Tipo"
                  name="type"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <Select
                    allowClear
                    placeholder="Selecione"
                    optionFilterProp="label"
                    showSearch
                    options={vehicleTypeOptions}
                    dropdownStyle={{ borderRadius: 16 }}
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Modelo"
                  name="model"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Ano"
                  name="year"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <InputNumber />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Placa"
                  name="licensePlate"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Cor"
                  name="color"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Capacidade"
                  name="capacity"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                  ]}
                >
                  <InputNumber />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Chassi"
                  name="chassis"
                  rules={[
                    {
                      required: true,
                      message: 'Campo obrigatório!',
                    },
                    { min: 17, max: 17, message: 'O Número do Chassi deve ter 17 caracteres!' },
                  ]}
                >
                  <Input maxLength={17} />
                </Form.Item>
              </Col>
            </Row>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Documentos" key="documentsData" forceRender>
            <Form.List name="documents">
              {(fields, { add, remove }) => (
                <>
                  {requiredDocuments?.length > 0 && (
                    <div>
                      <h3>Documentos Obrigatórios</h3>
                      <p style={{ margin: 0 }}>{requiredDocuments?.join(' / ')}</p>
                    </div>
                  )}

                  <Button
                    style={{
                      marginTop: 15,
                      marginBottom: 15,
                      width: 200,
                    }}
                    type="dashed"
                    onClick={() => {
                      add();
                    }}
                    block
                    icon={<PlusOutlined />}
                  >
                    Adicionar Documento
                  </Button>
                  <Row gutter={[24]}>
                    {fields.map(({ key, name, ...restField }) => (
                      <Col key={key} span={24}>
                        <Card
                          extra={
                            <Popconfirm
                              title="Deseja mesmo excluir?"
                              onConfirm={() => {
                                if (form.getFieldValue('documents')[name]?.downloadUrls) {
                                  CompanyFunctions.deleteDocumentFromStorage(form, 'driver', name);
                                  remove(name);
                                  submit(form.getFieldsValue());
                                } else {
                                  remove(name);
                                }
                              }}
                              okText="Sim"
                              cancelText="Não"
                            >
                              <CloseOutlined />
                            </Popconfirm>
                          }
                          style={{
                            backgroundColor: '#ffffff00',
                            borderColor: '#b7b7b7',
                            borderRadius: 16,
                            marginBottom: 10,
                          }}
                        >
                          <Col span={24}>
                            <Form.Item
                              {...restField}
                              name={[name, 'verified']}
                              valuePropName="checked"
                              initialValue={true}
                            >
                              <Checkbox>Verificado</Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              {...restField}
                              name={[name, 'type']}
                              label="Tipo de documento"
                              rules={[
                                {
                                  required: true,
                                  message: 'Campo obrigatório!',
                                },
                              ]}
                              getValueFromEvent={(_, object) => {
                                if (!object) return null;

                                return {
                                  ...object,
                                  name: object.label,
                                  id: object.value,
                                };
                              }}
                            >
                              <Select
                                options={documentTypeOptions}
                                allowClear
                                placeholder="Selecione"
                                optionFilterProp="label"
                                showSearch
                                dropdownStyle={{ borderRadius: 16 }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={24}>
                            <Form.Item
                              {...restField}
                              name={[name, 'number']}
                              label="Nº documento"
                              rules={[
                                {
                                  required: true,
                                  message: 'Campo obrigatório!',
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>

                          <Col span={24}>
                            <Form.Item
                              {...restField}
                              name={[name, 'validity']}
                              label="Validade"
                              rules={[
                                {
                                  required: false,
                                  message: 'Campo obrigatório!',
                                },
                              ]}
                            >
                              <DatePicker
                                format="DD-MM-YYYY"
                                style={{
                                  borderRadius: 16,
                                }}
                              />
                            </Form.Item>
                          </Col>

                          {form.getFieldValue('documents')[name]?.downloadUrls && (
                            <Col span={24}>
                              <Form.Item
                                {...restField}
                                name={[name, 'downloadUrls']}
                                label
                                style={{
                                  textAlign: 'center',
                                }}
                                rules={[
                                  {
                                    required: false,
                                    message: 'Campo obrigatório!',
                                  },
                                ]}
                              >
                                <List
                                  size="small"
                                  header={<div>Arquivos</div>}
                                  bordered
                                  dataSource={form.getFieldValue('documents')[name]?.downloadUrls}
                                  renderItem={({ label, url }) => (
                                    <List.Item>
                                      <a
                                        href={url}
                                        target="blank"
                                        style={{ wordBreak: 'break-word' }}
                                      >
                                        {label}
                                      </a>
                                    </List.Item>
                                  )}
                                />
                              </Form.Item>
                            </Col>
                          )}

                          {!form.getFieldValue('documents')[name]?.downloadUrls && (
                            <Col span={24}>
                              <Form.Item
                                {...restField}
                                name={[name, 'uploadFiles']}
                                label
                                style={{
                                  textAlign: 'center',
                                }}
                                rules={[
                                  {
                                    required: false,
                                    message: 'Campo obrigatório!',
                                  },
                                ]}
                              >
                                <Upload multiple beforeUpload={() => false}>
                                  <Button icon={<UploadOutlined />}>Upload de arquivos</Button>
                                </Upload>
                              </Form.Item>
                            </Col>
                          )}
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </>
              )}
            </Form.List>
          </Tabs.TabPane>
        </Tabs>
      </Form>
    </Drawer>
  );
}
